import assetPath from '/app/xinglets/lebenslauf/pages/startpage/src/assets/templates-preview-2x.png';
export default [globalThis.crate.assetsBaseUrl, assetPath].join('/')